import React, { ReactElement, useCallback, useEffect, useRef, useState } from "react";
import cn from "classnames";
import { Col, Form, Input, Popconfirm, Radio, Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import SocialShare from "../Referrals/InviteEarn/SocialShare";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Merchant, NewUser, Rider } from "../icons";
import ReferralCard from "../common/ReferralCard";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { LOGIN_SUCCESS } from "../../redux/auth/authType";
import { Loader } from "../common";
import DashboardCampaign from "./DashboardCampaign";
import { getParamValue } from "../../utils";
import { responseNotification } from "../../utils/notify";
import { useServiceTypeOptions } from "../../../src/hooks/useServiceTypeOptions";

const settings = {
  slidesPerView: 6,
  spaceBetween: 30,
  // pagination={true}
  pagination: {
    clickable: true,
  },
  navigation: true,
  breakpoints: {
    620: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
    1600: {
      slidesPerView: 1,
      spaceBetween: 30,
    },
  },
  modules: [Autoplay, Pagination, Navigation],
};

const statuses = [
  "PENDING",
  "INITIATED",
  "REQUESTED_TO_MERCHANT",
  "ACCEPTED_BY_MERCHANT",
  "READY_TO_PICKUP",
  "ON_DELIVERY",
  "COMPLETED",
  "CANCELLED",
  "RETURN",
];
const types = [
  { value: "JC_GROCERY", icon: "/departments/grocery.png" },
  { value: "JC_FOOD", icon: "/departments/food.png" },
  { value: "JC_MALL", icon: "/departments/mall.png" },
  { value: "JC_PAYMENT", icon: "/departments/topup.png" },
  { value: "JC_BOOKING", icon: "/departments/booking.png" },
  { value: "JC_RIDER", icon: "/departments/rider.png" },
  { value: "JC_PARCEL", icon: "/departments/parcel.png" },
  { value: "JC_MEDICINE", icon: "/departments/medicine.png" },
  { value: "JC_COMMERCE", icon: "/departments/fashion.png" },
];

const MainSellerDashboard = (): ReactElement => {
  const { token, type, shopInfo, shopId, merchantInfo, merchantId } =
    useSelector((state) => (state as any)?.authReducer);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const InputGroup = Input.Group;
  const isFetchingRef = useRef(false);
  const [visible, setVisible] = useState(false);
  const [orderData, setOrderData] = useState<any>();
  const [allServiceData, setAllServiceData] = useState<any>();
  const [allShopData, setAllShopData] = useState<any>();
  const [visiblePopconfirm, setVisiblePopconfirm] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [totalOrderData, setTotalOrderData] = useState<any>({
    loading: false,
    data: null,
  });
  const navigate = useNavigate();
  const [filterType, setFilterType] = useState<any>("day");
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState("");
  const [isActive, setIsActive] = useState<any>(undefined);
  const [campaignData, setCampaignData] = useState<any>({
    loading: false,
    data: null,
  });
  const [promotionData, setPromotionData] = useState<any>({
    loading: false,
    data: null,
  });
  const options = [
    {
      title: "Share with Friends",
      description:
        "Share this code with as many family members and friends as you want, and ask them to use it when signing up or placing an order at Jachai.com. In every purchase, both parties will benefit. ",
      icon: <NewUser />,
      referralCode: merchantInfo?.referralCode,
      colorCode: "rgba(185, 101, 224, 0.12)",
    },
    {
      title: "Share with Rider",
      description:
        "Share this code with as many family members and friends as you want, and ask them to use it when signing up or placing an order at Jachai.com. In every purchase, both parties will benefit. ",
      icon: <Rider />,
      referralCode: merchantInfo?.referralCode,
      colorCode: "#FDF0F0",
    },
    {
      title: "Share with Merchant",
      description:
        "Share this code with as many family members and friends as you want, and ask them to use it when signing up or placing an order at Jachai.com. In every purchase, both parties will benefit. ",
      icon: <Merchant />,
      referralCode: merchantInfo?.referralCode,
      colorCode: "#F4ECCE",
    },
  ];

  const getDateRangeByType = (filterType: string) => {
    const today = new Date(new Date().setUTCHours(0,0,0,0)).toISOString();

    const oneWeekAgo = new Date();
          oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
          oneWeekAgo.setUTCHours(0, 0, 0, 0);
    const OneWeekDate = oneWeekAgo.toISOString();
  
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    oneMonthAgo.setUTCHours(0, 0, 0, 0);
    const monthDate = oneMonthAgo.toISOString();

    switch (filterType) {
      case "day":
        return {
          from: today,
          to: today,
        };
  
      case "week":
        return {
          from: OneWeekDate,
          to: today,
        };
  
      case "month":
        return {
          from: monthDate,
          to: today,
        };
  
      case "lifetime":
        return {
          from: "2024-01-01T00:00:00.000Z",
          to: today,
        };
  
      default:
        return { from: null, to: null };
    }
  };
  
  const getApiPath = () => {
    if (shopInfo?.id) {
      return `/merchant/order/shop-total-order-count?shopId=${shopInfo?.id}`;
    }
    return `/merchant/order/merchant-total-order-count?merchantId=${merchantInfo?.id}`;
  };
  
  const getOrderData = useCallback(async () => {
    if (isFetchingRef.current) return; //prevent multiple calls
    isFetchingRef.current = true;
  
    setTotalOrderData({ data: null });
  
    const { from, to } = getDateRangeByType(filterType);
    const apiPath = getApiPath();
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
  
    // type removed
    const query =
      (from ? `&startAt=${from}` : ``) +
      (to ? `&endAt=${to}` : ``);
  
    try {
      const res = await axios.get(`${encodedUri}${apiPath}${query}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      setTotalOrderData({
        loading: false,
        data: res.data,
      });
    } catch (err) {
      console.error("totalOrder error", err);
      setTotalOrderData({ data: [] });
    } finally {
      isFetchingRef.current = false; // 🔓 unlock
    }
  }, [filterType, token, shopInfo]);
  
  
  useEffect(() => {
    getOrderData();
  }, [getOrderData]);
  

  const getOrderas = useCallback(async () => {
    setOrderData(null);

    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/order/order-counted-by-shopId?` +
          (merchantId ? `&merchantId=${merchantId}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``) +
          (statuses ? `&statuses=${statuses}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setOrderData(res.data);
      })
      .catch((err) => {
        setOrderData([]);
        console.error("Order: Error", err);
      });
  }, [shopId, merchantId]);

  const getMyAllService = useCallback(async () => {
    setAllServiceData(null);

    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(`${encodedUri}/merchant/my-all-service-types`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setAllServiceData(res?.data);
      })
      .catch((err) => {
        setAllServiceData([]);
        console.error("Order: Error", err);
      });
  }, []);

  const getMyAllShop = useCallback(async () => {
    setAllShopData(null);

    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(`${encodedUri}/merchant-shop/my-shop-v2?type=${type}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setAllShopData(res?.data);
      })
      .catch((err) => {
        setAllShopData([]);
        console.error("Order: Error", err);
      });
  }, [type]);

  const getCampaigns = useCallback(async () => {
    setCampaignData({ loading: true, data: null });

    const encodedUrl = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUrl}/admin/campaign/by-type?type=${type}&isActive=true&deleted=false&withUpcoming=true`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setCampaignData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setCampaignData({ loading: false, data: [] });
        console.error("Type: Error", err);
      });
  }, []);

  const getPromoCode = useCallback(async () => {
    setPromotionData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/promotion?type=${type}&placement=MARCHANT_DASHBOARD&page=${
          page || 0
        }&limit=${limit || 16}` +
          (key ? `&name=${key}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setPromotionData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setPromotionData({ loading: false, data: [] });
        console.error("Promotion: Error", err);
      });
  }, [key, limit, page, isActive, type]);

  const onSetDefault = async (shopId: any) => {
    if (shopId) {
      await fetch(
        `${process.env.REACT_APP_AUTH_API}/merchant/switch-to-shop-v2`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            shopId: shopId,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(res.message, "success");
            fetchShopDetails(res);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const fetchShopDetails = useCallback((res: any) => {
    if (res) {
      try {
        axios
          .get(
            `${process.env.REACT_APP_CATALOG_READER_API}/merchant-shop/my-shop-details?shopId=${res?.shopId}`,
            {
              headers: {
                Authorization: `Bearer ${res?.token}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              dispatch({
                type: LOGIN_SUCCESS,
                payload: {
                  token: res?.token,
                  // mobileNumber: res?.mobileNumber,
                  userType: res?.usertype || "MERCHANT",
                  shopInfo: data?.data?.shop,
                  shopId: data?.data?.shop?.id,
                  iat: new Date(),
                  type: data?.data?.shop?.type || "JC_COMMERCE",
                },
              });

              navigate("/");
            } else {
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    getOrderas();
    getMyAllService();
    getMyAllShop();
    getCampaigns();
    getPromoCode();
  }, [getOrderas, getMyAllService, getMyAllShop, getCampaigns, getPromoCode]);

  const showPopconfirm = (mobileNumber: any) => {
    setVisiblePopconfirm(mobileNumber);
  };

  const handleCancel = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setVisiblePopconfirm(undefined);
  };
  return (
    <>
      {promotionData?.data?.promotions > 0 && (
        <div className="bg-white rounded-md">
          <Swiper
            {...settings}
            className="mySwiper"
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            style={{ height: "300px" }}
          >
            {promotionData?.loading ? (
              <Loader />
            ) : (
              promotionData?.data?.promotions?.map((promotion, i) => (
                <SwiperSlide key={i}>
                  <div className="w-full bg-white shadow-md shadow-gray-200 hover:shadow-xl  border rounded-md">
                    <div className="w-full h-full md:h-full overflow-hidden ">
                      <Link to={promotion?.url}>
                        <img
                          src={promotion?.imageUrl}
                          alt=""
                          className="w-full h-full object-cover rounded-md"
                        />
                      </Link>
                    </div>
                  </div>
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
      )}
      {/* <div
        className={cn(
          `w-full text-center rounded-xl bg-white object-cover bg-cover bg-no-repeat bg-center h-60 border`
        )}
        style={{
          background: "url('/earningBg.jpg')",
          backgroundSize: "cover",
        }}
      ></div> */}
      <div className="">
        <InputGroup size="large">
          <Row gutter={12}>
            <Col span={12}>
              <Radio.Group
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
              >
                <Radio.Button value="day">Today</Radio.Button>
                <Radio.Button value="week">This Week</Radio.Button>
                <Radio.Button value="month">This Month</Radio.Button>
                <Radio.Button value="lifetime">Lifetime</Radio.Button>
              </Radio.Group>
            </Col>
            {/* <Col span={5}>
              <Form form={form} className="search_form">
                <Form.Item initialValue={type}>
                  <Select
                    options={serviceTypeOptions.list}
                    loading={serviceTypeOptions.loading}
                    onChange={(val) => setType(val)}
                    placeholder="Select Service Type"
                  />
                </Form.Item>
              </Form>
            </Col> */}
          </Row>
        </InputGroup>
      </div>

      <div className="grid grid-cols-2 gap-6 mb-6 w-full xl:grid-cols-4 2xl:grid-cols-4 mt-10">
      {totalOrderData?.data?.orders?.length ? (
                      totalOrderData?.data?.orders?.map(
                        (order: any, index: any) => (
        
<Link to="#">
  <div className="bg-white rounded-2xl p-5 shadow-md flex items-center space-x-4">

    {/* Count + Total + Status */}
    <div className="flex flex-col">
      
      {/* Count */}
      <div className="text-2xl font-bold text-gray-900 leading-none">
        {order?.count ?? 0}
      </div>

      {/* Total */}
      <div className="text-xl font-semibold text-gray-800 mt-1 leading-none">
        ৳ {order?.total ?? 0}
      </div>

      {/* Status */}
      <div className="text-base text-gray-500 mt-2 uppercase tracking-wide font-medium">
        {order?.status ?? "UNKNOWN"}
      </div>

    </div>
  </div>
</Link>


                        
                        
             )
            )
          ) : (
            <>
     <Link to="#">
          <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 ">
            <div className="flex items-center">
              <div className="inline-flex flex-shrink-0 justify-center items-center w-12 h-12 text-white bg-gradient-to-br from-pink-500 to-purple-700 rounded-lg">
                <svg
                  viewBox="0 0 1000 1000"
                  fill="currentColor"
                  height="1em"
                  width="1em"
                >
                  <path d="M1000 940H776V790c0-36-10-63-30-81s-71.333-47.667-154-89c26.667-20 40-48 40-84 0-10.667-4.333-21.667-13-33-8.667-11.333-15-28.333-19-51-1.333-5.333-6-10.667-14-16s-12.667-19.333-14-42c0-16 4-26 12-30-4-22.667-6.667-42.667-8-60-2.667-25.333 5-51.333 23-78s49.667-40 95-40 77.333 13.333 96 40 26.667 52.667 24 78l-8 60c8 4 12 14 12 30-1.333 22.667-6 36.667-14 42-8 5.333-12.667 10.667-14 16-4 22.667-10.333 39.667-19 51-8.667 11.333-13 22.333-13 33 0 28 7 50 21 66s39.667 32 77 48c74.667 30.667 118 57.333 130 80 4 5.333 7 25.667 9 61s3.667 69 5 101v48M512 678c121.333 52 182 93.333 182 124v138H0V756c0-29.333 28-55.333 84-78 50.667-21.333 85.333-42.667 104-64s28-50.667 28-88c0-13.333-6.333-28-19-44s-21-38.667-25-68c-1.333-6.667-7.333-14-18-22s-17.333-26.667-20-56c0-9.333 1-17 3-23s4.333-10.333 7-13l4-2c-4-30.667-7.333-58-10-82-2.667-33.333 8.333-67.667 33-103s67-53 127-53 102.333 17.667 127 53 35.667 69.667 33 103l-10 82c9.333 5.333 14 18 14 38-2.667 29.333-9.333 48-20 56s-16.667 15.333-18 22c-4 29.333-12.333 52-25 68s-19 30.667-19 44c0 37.333 9.333 66.667 28 88s53.333 42.667 104 64" />
                </svg>
              </div>
              <div className="flex-shrink-0 ml-3">
                <span className="text-2xl font-bold leading-none text-gray-900">
                  0.00
                </span>

                <h3 className="text-base font-normal text-gray-500">
                Requested
                </h3>
              </div>
            </div>
          </div>
        </Link>
            </>
          )}
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-2 md:grid-cols-2  mt-10 mb-10">
        <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 ">
          <div>
            <h3 className="mb-2 text-xl font-bold text-gray-900">My Service</h3>
          </div>
          <div className="grid grid-cols-2 gap-x-6">
            {allServiceData?.types?.map(
              (serviceType: any, serviceIndex: any) => (
                <Link to="#">
                  <div
                    key={serviceIndex}
                    className={cn(
                      "shadow hover:shadow-lg rounded-md p-2 text-center cursor-pointer m-2",
                      {
                        ["bg-green-50 border border-green-500 shadow-lg m-2"]:
                          type === (serviceType?.type as any),
                      }
                    )}
                    onClick={() => {
                      dispatch({
                        type: LOGIN_SUCCESS,
                        payload: {
                          type: serviceType?.type,
                        },
                      });
                      getMyAllShop();
                    }}
                  >
                    <div className="flex items-center">
                      <div className="inline-flex flex-shrink-0 justify-center items-center w-12 h-12 text-white bg-gradient-to-br rounded-lg">
                        {types?.map(
                          (serViceTypeData, serViceTypeDataIndex) =>
                            serViceTypeData?.value === serviceType?.type && (
                              <>
                                <img
                                  src={serViceTypeData?.icon}
                                  className="m-auto mb-4 h-12"
                                  alt="Loading"
                                />
                              </>
                            )
                        )}
                      </div>
                      <div className="flex-shrink-0 ml-3">
                        <h3 className="text-base font-normal text-gray-500">
                          {serviceType?.type?.replace("_", " ")}
                        </h3>
                      </div>
                    </div>
                  </div>
                </Link>
              )
            )}
          </div>
        </div>
        {shopInfo?.id == null && (
          <>
            <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 ">
              <div>
                <h3 className="mb-2 text-xl font-bold text-gray-900">
                  My Business
                </h3>
              </div>
              <div className="grid grid-cols-2 gap-x-6">
                {allShopData?.shops?.map((shop: any, shopIndex: any) => (
                  <Popconfirm
                    placement="left"
                    title="Do you want to login this store?"
                    visible={shop?.mobileNumber === visiblePopconfirm}
                    onConfirm={(e: any) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onSetDefault(shop?.id);
                    }}
                    okButtonProps={{
                      loading: confirmLoading,
                      className: "bg-blue-400",
                      shape: "round",
                    }}
                    cancelButtonProps={{
                      danger: true,
                      type: "primary",
                      shape: "round",
                    }}
                    okText="Yes"
                    cancelText="Not now"
                    onCancel={handleCancel}
                  >
                    <Link
                      to={""}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        showPopconfirm(shop?.mobileNumber);
                      }}
                    >
                      <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-4">
                        <div className="flex items-center">
                          <div className="inline-flex flex-shrink-0 justify-center items-center w-12 h-12 text-white bg-gradient-to-br rounded-lg">
                            <img
                              src={shop?.logo}
                              className="m-auto mb-4 h-12"
                              alt="Loading"
                            />
                          </div>
                          <div className="flex-shrink-0 ml-3">
                            <h3 className="text-base font-normal text-gray-500">
                              {shop?.name}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </Popconfirm>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      <DashboardCampaign />
      <div className="block mb-10 mt-8">
        <div className={cn(`rounded-xl border bg-white min-h-full`)}>
          <div className="p-5 border-b text-lg font-semibold">
            Referral & Share
          </div>
          <div className="p-4 lg:p-10 flex flex-col justify-center gap-4">
            <div className="grid grid-cols-3 gap-6">
              {options?.map((data: any, i: number) => (
                <ReferralCard
                  data={data}
                  key={i}
                  setVisible={setVisible}
                  visible={visible}
                />
              ))}
            </div>

            {visible && (
              <>
                <span className="text-center font-bold text-xl lg:text-2xl mt-12">
                  Share this code
                </span>
                <SocialShare />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MainSellerDashboard;
